import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { Card, CardContent, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { Event } from "../../models/Event";
import { useEventComparisonData } from "./useEventComparisonData";

export const EventComparisonTable = ({ event }: { event: Event | null }) => {
	const { defaultColDef } = useGridDefinitions({});
	const { columnDefs } = useEventComparisonData();

	if (!event) return null;

	return (
		<Card sx={{ width: "100%" }}>
			<CardContent>
				<Typography variant="h6" fontWeight={600} fontSize="1rem">
					Event Data Summary
				</Typography>
				<div style={{ height: 150, width: "100%" }}>
					<AgGridReact
						rowData={[event]}
						columnDefs={columnDefs}
						defaultColDef={defaultColDef}
						rowHeight={35}
						headerHeight={45}
						overlayNoRowsTemplate={"-"}
						suppressContextMenu
						suppressColumnVirtualisation
					/>
				</div>
			</CardContent>
		</Card>
	);
};
